import { Asset } from 'app/shared/collections/asset';
import ImsObjectCollection from 'app/shared/collections/ims_object_collection.service';
import { IpDevice } from 'app/shared/collections/ip_device';
import { Zone } from 'app/shared/collections/zones/zone';
import { IMSAggregator } from 'app/views/aggregators/aggregator';
import { ILabelGetter } from 'app/views/value_getters/ILabelGetter';
import { IMSValueGetter } from 'app/views/value_getters/value_getter';
import { ColourObject } from 'app/views/view_types/network/value_getters/associated_ap_value_getter';

export class IMSObjectNameLabelValueGetter implements ILabelGetter {
    private valueGetter: IMSValueGetter;
    private collection: ImsObjectCollection;

    /**
     * Wraps a normal value getter - expecting back an ims object id; and returns the name of that ims object
     *  from the given collection
     */
    constructor(valueGetter: IMSValueGetter, collection: ImsObjectCollection) {
        this.valueGetter = valueGetter;
        this.collection = collection;
    }

    private getLabel(
        farObjectId: ColourObject | string | number | null | undefined,
    ): string | null {
        const farObj = this.collection.get(farObjectId);
        if (!farObj?.name) {
            return null;
        }

        return farObj.name;
    }

    public getFormattedValueForAsset(
        asset: Asset,
        time: Cesium.JulianDate,
        agg: IMSAggregator,
    ): string {
        const id = this.valueGetter.getValueForAsset(asset, time, agg);
        return this.getLabel(id);
    }

    public getFormattedValueForIPDevice(
        ipDevice: IpDevice,
        time: Cesium.JulianDate,
        agg: IMSAggregator,
    ): string {
        const id = this.valueGetter.getValueForIPDevice(ipDevice, time, agg);
        return this.getLabel(id);
    }

    public getFormattedValueForZone(
        zone: Zone,
        time: Cesium.JulianDate,
        agg: IMSAggregator,
    ): string {
        const id = this.valueGetter.getValueForZone(zone, time, agg);
        return this.getLabel(id);
    }
}
